import React, { useState, useEffect } from "react";
import Navbar from "../../../../Navbar";
import { useParams } from "react-router-dom";
import { Container, Grid, Paper, Typography, Button, Box, TextField } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import { getDataIx0 } from "../../../../../services/library"
import { enviarmails } from "../../../../../services/services"
import { UrlApi } from "../../../../../services/apirest"
import { armaMailSolicitudAprobada } from "./armaMail";
import { getData } from "../../../../../services/library";


function AprobacionCambioTitularidad() {
    const accesoPermitido = localStorage.getItem("role") === "admin" && localStorage.getItem("sector") === "5";
    const { id_cliente_nuevo } = useParams();
    const [nuevoTitular, setNuevoTitular] = useState(null);
    const [titularOriginal, setTitularOriginal] = useState(null);
    const [parametros, setParametros] = useState();

    const buscarDatos = async () => {
        const respuesta = await fetch(UrlApi + "/clientes/" + id_cliente_nuevo)
        const nuevoTitular = await respuesta.json();
        console.log(nuevoTitular)


        if (nuevoTitular.length === 0 || (nuevoTitular.length > 0 && (nuevoTitular[0].activo === 1 || nuevoTitular[0].id_titular_anterior === null))) {
            alert("No existe cambio de titularidad pendiente.")
            handleClose();
        }
        setNuevoTitular(nuevoTitular[0])
        getDataIx0("/clientes/" + nuevoTitular[0]?.id_titular_anterior, setTitularOriginal)
    }

    useEffect(() => {
        if (accesoPermitido) buscarDatos();
        getData("/cambio_titularidad_parametros", setParametros)
    }, [id_cliente_nuevo]);

    const handleClose = () => {
        window.location.replace(`/#/navbar`); //lo comento porqe estoy probando pero es lo q tiene q suceder
    };

    const aprobar = async (e) => {
        e.preventDefault();
        const dirCorreoGranel = parametros.filter((p) => p.parametro === "destinatarios_solicitudaprobada")[0].valor
        const dirCorreoSolicitante = nuevoTitular.email_solicitante_cambiotitularidad; //direccion de correo del usuario que solicito el cambio de titularidad (clientes.usuario_cambia_titularidad)
        const dirCorreoPlantaCliente = nuevoTitular.mail_sucursal
        const dirCorreoComercialCliente = nuevoTitular.mail_comercial
        // console.log("dirCorreoGranel", dirCorreoGranel)
        // console.log("dirCorreoSolicitante", dirCorreoSolicitante)
        // console.log("dirCorreoPlantaCliente", dirCorreoPlantaCliente)
        // console.log("dirCorreoComercialCliente", dirCorreoComercialCliente)
        try {
            const reqBody = {
                dataClienteOriginal: titularOriginal,
                dataNuevoCliente: { ...nuevoTitular, activo: 1 }
            }
            const response = await fetch(UrlApi + "/clientes/ejecutar_cambio_titularidad/", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(reqBody),
            });
            if (!response.ok) alert("No se pudo aprobar el cambio de titularidad.");
            else {
                const json = await response.json();
                const { id_cliente_nuevo } = json;
                if (id_cliente_nuevo) {
                    const mail = armaMailSolicitudAprobada(reqBody, id_cliente_nuevo)
                    enviarmails(
                        `${dirCorreoGranel};${dirCorreoSolicitante};${dirCorreoPlantaCliente};${dirCorreoComercialCliente}`,
                        "Solicitud cambio titularidad APROBADA", mail
                    );
                    alert("Aprobacion de cambio de titularidad exitosa.")
                    handleClose();
                } else {
                    alert("No se pudo aprobar el cambio de titularidad.")
                }
            }
        } catch (error) {
            alert("No se pudo aprobar el cambio de titularidad.")
        }
    }

    return (
      <div style={{ backgroundColor: "#ebebeb", minHeight: "100vh" }}>
        <Navbar />
        <Container maxWidth="lg">
          {!accesoPermitido && typeof window !== "undefined" && (
            <>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                m={2}
              >
                <Grid item xs={12}>
                  <Typography variant="h6" color="error" x>
                    ! ACCESO DENEGADO
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">
                    No tiene permisos para realizar esta accion..
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
          {!!nuevoTitular && !!titularOriginal ? (
            <>
              <Paper
                variant="elevation"
                elevation={10}
                style={{ borderRadius: 0, p: 3 }}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  alignContent="stretch"
                  wrap="wrap"
                  my={2}
                  borderRadius={10}
                >
                  <Grid
                    item
                    xs={1}
                    backgroundColor="#de4331"
                    textAlign="center"
                    p={1}
                  >
                    <VerifiedIcon style={{ color: "#fff", fontSize: 30 }} />
                  </Grid>
                  <Grid item xs={11} backgroundColor="white" p={1}>
                    <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                      Aprobar Cambio Titularidad
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              <Paper
                variant="elevation"
                elevation={10}
                style={{ borderRadius: 0, p: 2 }}
              >
                <Grid
                  container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  alignContent="stretch"
                  wrap="wrap"
                  my={2}
                  borderRadius={10}
                  p={2}
                >
                  <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                    Se solicita realizar el cambio de titularidad del cliente{" "}
                    <b>{titularOriginal.razon_social}</b> (Sisven N.º{" "}
                    {titularOriginal.sisven_id}), transfiriendo dicha
                    titularidad a nombre del cliente{" "}
                    <b>{nuevoTitular.razon_social}</b>.
                  </Typography>
                  <hr />
                  <Typography
                    variant="body1"
                    color="initial"
                    sx={{ ml: 1 }}
                    textAlign="center"
                    fontSize={18}
                  >
                    <b>
                      <u>Datos de NUEVO TITULAR:</u>
                    </b>
                  </Typography>

                  <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                    <b>Razon Social:</b> {nuevoTitular.razon_social} (Cuit/Dni:
                    {nuevoTitular.cuit})
                  </Typography>

                  <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                    <b>Situación IVA:</b> {nuevoTitular.nombre_situacioniva}
                  </Typography>

                  {nuevoTitular?.convenio && (
                    <>
                      <Typography
                        variant="body1"
                        color="initial"
                        sx={{ ml: 1 }}
                      >
                        <b>Convenio:</b> {nuevoTitular.convenio} (N° Inscr: {nuevoTitular?.iibb_nro_inscripcion || "No regitrado."})
                      </Typography>
                    </>
                  )}

                  <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                    <b>Condicion de Pago:</b> {nuevoTitular.condicion}
                  </Typography>

                  <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                    <b>Direccion Fiscal:</b> {nuevoTitular.direccion_fiscal} (
                    {nuevoTitular.localidad}, {nuevoTitular.provincia})
                  </Typography>
                  <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                    <b>Sucursal:</b> {nuevoTitular.sucursal} (
                    {nuevoTitular.empresa})
                  </Typography>
                  <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                    <b>Segmento:</b> {nuevoTitular.segmento}
                  </Typography>
                  <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                    <b>Teléfono:</b> {nuevoTitular.telefono1}
                  </Typography>
                  {!!nuevoTitular.telefono2 && (
                    <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                      <b>Teléfono :</b> {nuevoTitular.telefono2}
                    </Typography>
                  )}
                  {!!nuevoTitular.telefono3 && (
                    <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                      <b>Teléfono:</b> {nuevoTitular.telefono3}
                    </Typography>
                  )}
                  <Typography variant="body1" color="initial" sx={{ ml: 1 }}>
                    <b>Mails:</b> {nuevoTitular.mails}
                  </Typography>
                  <form onSubmit={aprobar} style={{ width: "100%" }}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="flex-start"
                      spacing={1}
                    >
                      <Grid item xs={2}>
                        <Typography
                          variant="body1"
                          color="initial"
                          sx={{ ml: 1 }}
                        >
                          <b>N° DE SISVEN:</b>
                        </Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <TextField
                          required
                          fullWidth
                          variant="standard"
                          size="small"
                          value={nuevoTitular.sisven_id}
                          onChange={(e) =>
                            setNuevoTitular({
                              ...nuevoTitular,
                              sisven_id: e.target.value || null,
                            })
                          }
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          inputProps={{ maxLength: 6 }}
                        />
                      </Grid>
                      <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="flex-start"
                        mt={1}
                      >
                        <Grid item xs={2}>
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            type="submit"
                          >
                            Aprobar
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Paper>
            </>
          ) : (
            <>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                sx={{ p: 3 }}
                height="90vh"
              >
                <Typography variant="body1" color="warning" fontSize={30}>
                  Contenido no disponible..
                </Typography>
              </Grid>
            </>
          )}
        </Container>
      </div>
    );
}

export default AprobacionCambioTitularidad;
